















































































































import {mapGetters} from 'vuex';
import Vue from 'vue';

interface ComponentData {
  listItems: {
    id: number;
    icon: string;
    text: string;
    link: string;
  }[];
  listItemsAdmin: {
    id: string;
    icon: string;
    text: string;
    link: string;
  }[];
}

export default Vue.extend({
  name: 'MenuDrawer',

  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },

  data: function (): ComponentData {
    return {
      listItems: [
        {
          id: 1,
          icon: 'nv-home',
          text: this.$t('template.sideMenu.home') as string,
          link: 'DefaultList',
        },
        {
          id: 2,
          icon: 'us-files',
          text: this.$t('template.sideMenu.adverts') as string,
          link: 'AdvertList',
        },
        {
          id: 3,
          icon: 'nv-file-add',
          text: this.$t('template.sideMenu.create') as string,
          link: 'AdvertCreation',
        },
        {
          id: 4,
          icon: 'nv-file-favorite-star',
          text: this.$t('template.sideMenu.favorites') as string,
          link: 'FavoriteList',
        },
        {
          id: 5,
          icon: 'nv-folders',
          text: this.$t('template.sideMenu.myAdverts') as string,
          link: 'PersonalAdvertList',
        },
        {
          id: 6,
          icon: 'us-comments-alt-o',
          text: this.$t('template.sideMenu.myMessages') as string,
          link: 'MessageList',
        },
        {
          id: 7,
          icon: 'nv-user',
          text: this.$t('template.sideMenu.account') as string,
          link: 'ProfileDetail',
        },
        {
          id: 8,
          icon: 'nv-alarm',
          text: this.$t('template.sideMenu.notifications') as string,
          link: 'Notifications',
        },
      ],
      listItemsAdmin: [
        {
          id: 'a1',
          icon: 'nv-organization-file-arborescence',
          text: this.$t('template.sideMenu.categories') as string,
          link: 'AdminCategories',
        },
        {
          id: 'a2',
          icon: 'nv-email-envelope',
          text: this.$t('template.sideMenu.adminMessages') as string,
          link: 'AdminMessages',
        },
        {
          id: 'a3',
          icon: 'us-bar-chart',
          text: this.$t('template.sideMenu.stats') as string,
          link: 'AdminStats',
        },
      ],
    };
  },

  computed: {
    ...mapGetters([
      'isAdmin',
      'messageUnreadNumber',
    ]),
    externalDocumentationUrl(): string {
      return process.env.VUE_APP_EXTERNAL_DOCUMENTATION_URL || '';
    },
    hasExternalDocumentation(): boolean {
      return process.env.VUE_APP_HAS_EXTERNAL_DOCUMENTATION === 'true';
    },
    tabIndex(): 0 | -1 {
      return this.active ? 0 : -1;
    },
  },

  watch: {
    active() {
      /**
       * Recommandation pour l'accessibilité, pour que la touche tab tourne en boucle dans le menu.
       */
      if (this.active) {
        (this.$el.querySelector('#menu-drawer__logo') as HTMLDivElement).focus();

        this.$el.addEventListener('keydown', (event) => {
          if ((event as KeyboardEvent).key !== 'Tab') return;
          let elements: HTMLDivElement[] = [];

          elements.push(this.$el.querySelector('#menu-drawer__logo') as HTMLDivElement);
          this.$el.querySelectorAll('#nav__side div[role=listitem]')
              .forEach((element) => {
                elements.push(element as HTMLDivElement);
              });

          const firstElement = elements[0];
          const lastElement = elements[(elements.length - 1)];

          if ((event as KeyboardEvent).shiftKey && (event as KeyboardEvent).target === firstElement) {
            event.preventDefault();
            lastElement?.focus();
          } else if (event.target === lastElement) {
            event.preventDefault();
            firstElement?.focus();
          }
        });
      }
    },
  },

  methods: {
    onGoToSuggestionForm(): void {
      window.open(process.env.VUE_APP_SUGGESTION_FORM_URL, '_blank');
    },
    onLogout(): void {
      localStorage.removeItem('JWT__access__token');
      localStorage.removeItem('JWT__refresh__token');
      window.location.href = 'https://ernest.unistra.fr';
    },
    onNavigate(routeName: string): Promise<void> {
      return new Promise((resolve, reject) => {
        this.$emit('update:active', false);
        this.$router.push({name: routeName})
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
      });
    },
  },
});
